module.exports = __webpack_public_path__ + "static/media/Day-Planner.2efe19e6.png";